import { Component, Input, OnInit } from '@angular/core';
import { LanguageService } from 'src/app/@shared/services/language/language.service';
import { UtilsService } from 'src/app/@shared/services/utils/utils.service';
import { ACCIDENT, CONSTRUCTION, DEMONSTRATION, DUE_TO, FROM, FROM_DATE, HOLIDAY, MAINTENANCE, MEDICAL_EMERGENCY, POLICE_ACTIVITY, SIGNIFICANT_DELAYS_WILL_BE_EXPERIENCED, STATIONS_WILL_BE_CANCLED, STRIKE, TECHNICAL_PROBLEM, THERE_MAY_BE_CHANGES, TO_DATE, TRIPS_WILL_BE_ADDED, TRIPS_WILL_BE_CANCELLED, UNKNOWN_CAUSE, UNTIL, WEATHER } from 'src/app/modules/route-planner/constants/multi-language.constants';
import { eSpecialMessagesCauses, eSpecialMessagesEffects } from 'src/app/modules/route-planner/constants/special-messages.constants';
import { SpecialMessage } from 'src/app/modules/route-planner/interfaces/route-planning/gtfs/special-messages/special-message.interface';

@Component({
    selector: 'app-special-message-pop-up-header',
    templateUrl: './special-message-pop-up-header.component.html',
    styleUrls: ['./special-message-pop-up-header.component.scss'],
    standalone: false
})
export class SpecialMessagePopUpHeaderComponent implements OnInit {
  @Input() message: SpecialMessage
  @Input() isPreview: boolean = false
  @Input() isShowHeader: boolean = true

  startDate: string
  endDate: string
  headerText: string
  fromDateText: string
  toDateText: string

  causeText: string
  effectText: string
  dueToText: string



  constructor(
    private readonly utilService: UtilsService,
    private readonly languageService: LanguageService
  ) {

  }

  ngOnInit(): void {
    this.startDate = this.setDate(this.message.fromDateToShow || this.message.fromDate)
    this.endDate = this.setDate(this.message.toDateToShow || this.message.toDate)
    this.initializeMultiLanguageTexts()
  }

  setDate(requestedDate: Date): string {
    const date = new Date(requestedDate);

    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();

    return `${day}.${month}.${year} ${hours}:${minutes}`;
  }

  initializeMultiLanguageTexts() {
    this.languageService.selectedLanguage$.subscribe(language => {
      this.fromDateText = FROM[language.language]
      this.toDateText = UNTIL[language.language]
      this.headerText = this.utilService.decodeUnicode(this.message.header[language.language]) || this.utilService.decodeUnicode(this.message.header.hebrew)
      this.dueToText = DUE_TO[language.language]

      switch (this.message.effect.id) {
        case eSpecialMessagesEffects.ADDITIONAL_SERVICE:
          this.effectText = TRIPS_WILL_BE_ADDED[language.language]
          break
        case eSpecialMessagesEffects.MODIFIED_SERVICE:
        case eSpecialMessagesEffects.OTHER_EFFECT:
        case eSpecialMessagesEffects.UNKNOWN_EFFECT:
          this.effectText = THERE_MAY_BE_CHANGES[language.language]
          break
        case eSpecialMessagesEffects.DETOUR:
        case eSpecialMessagesEffects.NO_SERVICE:
        case eSpecialMessagesEffects.STOP_MOVED:
          if (this.message.allAffectedStops && this.message.allAffectedStops.length) {
            this.effectText = `${STATIONS_WILL_BE_CANCLED[language.language]}:`
          } else {
            this.effectText = THERE_MAY_BE_CHANGES[language.language]
          }
          break
        case eSpecialMessagesEffects.REDUCED_SERVICE:
          this.effectText = TRIPS_WILL_BE_CANCELLED[language.language]
          break
        case eSpecialMessagesEffects.SIGNIFICANT_DELAYS:
          this.effectText = SIGNIFICANT_DELAYS_WILL_BE_EXPERIENCED[language.language]
          break
      }

      switch (this.message.cause.id) {
        case eSpecialMessagesCauses.ACCIDENT:
          this.causeText = ACCIDENT[language.language]
          break
        case eSpecialMessagesCauses.CONSTRUCTION:
          this.causeText = CONSTRUCTION[language.language]
          break
        case eSpecialMessagesCauses.DEMONSTRATION:
          this.causeText = DEMONSTRATION[language.language]
          break
        case eSpecialMessagesCauses.HOLIDAY:
          this.causeText = HOLIDAY[language.language]
          break
        case eSpecialMessagesCauses.MAINTENANCE:
          this.causeText = MAINTENANCE[language.language]
          break
        case eSpecialMessagesCauses.MEDICAL_EMERGENCY:
          this.causeText = MEDICAL_EMERGENCY[language.language]
          break
        case eSpecialMessagesCauses.POLICE_ACTIVITY:
          this.causeText = POLICE_ACTIVITY[language.language]
          break
        case eSpecialMessagesCauses.STRIKE:
          this.causeText = STRIKE[language.language]
          break
        case eSpecialMessagesCauses.TECHNICAL_PROBLEM:
          this.causeText = TECHNICAL_PROBLEM[language.language]
          break
        case eSpecialMessagesCauses.UNKNOWN_CAUSE:
        case eSpecialMessagesCauses.OTHER_CAUSE:
          this.causeText = UNKNOWN_CAUSE[language.language]
          break
        case eSpecialMessagesCauses.WEATHER:
          this.causeText = WEATHER[language.language]
          break
      }
    })
  }
}
